import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";

export default function useRouterTransition(timeout = 300) {
  const location = useLocation();
  const prevLocation = useRef(location);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    if (location !== prevLocation.current) {
      setTransitioning(true);

      // reset after short delay (simulate transition end)
      const timer = setTimeout(() => setTransitioning(false), timeout);

      prevLocation.current = location;
      return () => clearTimeout(timer);
    }
  }, [location, timeout]);

  return transitioning;
}
